<button
  class="feedback-email-button__button"
  target="_blank"
  rel="noopener noreferrer"
  tgButton2
  (click)="isFeedbackModalVisible = true">
  Tell us what you think
</button>
<tm-feedback
  *ngIf="isFeedbackModalVisible"
  [categoryId]="categoryId"
  [subCategory]="subCategory"
  [step]="step"
  [listingId]="listingId"
  (closeModal)="onFeedbackClose()">
</tm-feedback>
